import {
  Box,
  Chip,
  debounce,
  FormControl,
  Grid2,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "urql";
import { dexesQuery } from "../../support/mutations";
import NotificationToggleButton from "../NotificationToggleButton";

const ApprovalsFilter = ({ filters, setFilters }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState("");
  const [minSupplyPercent, setMinSupplyPercent] = useState(5);
  const [dexName, setDexName] = useState([]);
  const [{ data }] = useQuery({
    query: dexesQuery,
    variables: { networkId: 1 },
  });

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setDexName(value);
    setFilters((prev) => ({
      ...prev,
      spenders: value.map((e) => e.address),
    }));
    if (value.length)
      setSearchParams((prev) => {
        prev.set("dexes", value.map((e) => e.address).join(","));
        return prev;
      });
    else
      setSearchParams((prev) => {
        prev.delete("dexes");
        return prev;
      });
  };

  useEffect(() => {
    if (data)
      setFilters((prev) => {
        let query = searchParams.get("query");
        if (query) {
          setQuery(query);
          prev.query = query;
        }

        let minSupplyPercentParam = searchParams.get("minSupplyPercent");
        if (minSupplyPercentParam) {
          setMinSupplyPercent(minSupplyPercentParam);
          prev.minSupplyPercent = minSupplyPercentParam;
        } else prev.minSupplyPercent = minSupplyPercent;

        return prev;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (data)
      setSearchParams((prev) => {
        if (query) prev.set("query", query);
        else prev.delete("query");
        if (filters.minSupplyPercent)
          prev.set("minSupplyPercent", filters.minSupplyPercent);
        else prev.delete("minSupplyPercent");

        return prev;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, query, filters.minSupplyPercent]);

  useEffect(() => {
    if (data?.dexes) {
      let dexes = searchParams.get("dexes");
      if (dexes && !dexName.length) {
        setFilters((prev) => {
          dexes = dexes.split(",").map((address) => {
            return data.dexes.find((d) => d.address === address);
          });
          setDexName(dexes);
          prev.spenders = dexes.map((e) => e.address);

          return prev;
        });
      }
    }
  }, [searchParams, setFilters, data, dexName]);

  const setMinSupplyPercentDebounced = useMemo(
    () =>
      debounce(
        (newValue) =>
          setFilters((prev) => ({
            ...prev,
            minSupplyPercent: newValue,
          })),
        500
      ),
    [setFilters]
  );

  const setQueryDebounced = useMemo(
    () =>
      debounce((e) => {
        setFilters((prev) => ({ ...prev, query: e.target.value }));
      }, 500),
    [setFilters]
  );

  return (
    <Grid2
      container
      spacing={2}
      sx={{ padding: 2, marginBottom: 1, width: "100%" }}
    >
      <Grid2 container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid2 size={{ xs: "grow", sm: "grow", md: 8, lg: 6, xl: 5 }}>
          <TextField
            sx={{ width: "100%" }}
            size="small"
            variant="outlined"
            label="Search"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setQueryDebounced(e);
            }}
          />
        </Grid2>
        <Grid2
          size={"grow"}
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
        />
        <Grid2 size={"auto"}>
          <NotificationToggleButton topic={"APPROVAL"} />
        </Grid2>
      </Grid2>
      <Grid2
        size={{ xs: 12, sm: 12, md: 5, lg: 4, xl: 3 }}
        sx={{ paddingRight: { xs: 2, sm: 1 }, paddingLeft: { xs: 2, sm: 1 } }}
      >
        <Typography id="input-slider" variant="caption">
          Min Suppy %
        </Typography>
        <Slider
          min={1}
          max={100}
          step={1}
          size="small"
          aria-label="Small"
          valueLabelDisplay="auto"
          value={minSupplyPercent}
          onChange={(_, newValue) => setMinSupplyPercent(newValue)}
          onChangeCommitted={(_, newValue) => {
            setMinSupplyPercentDebounced(newValue);
          }}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 2 }}>
        <FormControl sx={{ width: "100%" }}>
          <InputLabel id="demo-multiple-chip-label" shrink={true}>
            Dexes
          </InputLabel>
          <Select
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            multiple
            size="small"
            value={dexName}
            displayEmpty
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            renderValue={(selected) =>
              selected.length === 0 ? (
                "All"
              ) : (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value.id} label={value.name} />
                  ))}
                </Box>
              )
            }
          >
            {data?.dexes?.map((dex) => (
              <MenuItem
                key={dex.id}
                value={dex}
                //style={getStyles(name, personName, theme)}
              >
                {dex.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid2>
    </Grid2>
  );
};

export default ApprovalsFilter;
